<template>
  <div class="navigatorContainer">
    <div class="item">
      <a-tooltip
        effect="dark"
        title="回到根节点"
        placement="top"
      >
        <div class="btn iconfont icondingwei" @click="backToRoot" />
      </a-tooltip>
    </div>
    <div v-if="false" class="item">
      <div class="btn iconfont iconsousuo" @click="showSearch" />
    </div>
    <div class="item">
      <MouseAction :mind-map="mindMap" />
    </div>
    <div class="item">
      <a-tooltip
        effect="dark"
        :title="
          openMiniMap
            ? '关闭小地图'
            : '开启小地图'
        "
        placement="top"
      >
        <div class="btn iconfont icondaohang1" @click="toggleMiniMap" />
      </a-tooltip>
    </div>
    <div class="item">
      <Scale :mind-map="mindMap" />
    </div>
    <div class="item">
      <Fullscreen :mind-map="mindMap" />
    </div>
    <div class="item">
      <div
        class="btn iconfont"
        @click="toggleDark"
      />
    </div>
  </div>
</template>

<script>
import Scale from './Scale';
import Fullscreen from './Fullscreen';
import { langList } from '../config';
import { getLang } from '../api';
import { mapState, mapMutations } from 'vuex';
import pkg from 'simple-mind-map/package.json';
import MouseAction from './MouseAction.vue';

/**
 * @Author: 王林
 * @Date: 2021-06-24 22:53:10
 * @Desc: 导航器工具栏
 */
export default {
  name: 'NavigatorToolbar',
  components: {
    Scale,
    Fullscreen,
    MouseAction
  },
  props: {
    mindMap: {
      type: Object
    }
  },
  data() {
    return {
      version: pkg.version,
      langList,
      lang: '',
      openMiniMap: false
    };
  },
  computed: {
    ...mapState({
      isReadonly: state => state.isReadonly
    })
  },
  created() {
    this.lang = getLang();
  },
  methods: {
    ...mapMutations(['setLocalConfig', 'setIsReadonly']),

    readonlyChange() {
      this.setIsReadonly(!this.isReadonly);
      this.mindMap.setMode(this.isReadonly ? 'readonly' : 'edit');
    },

    toggleMiniMap() {
      this.openMiniMap = !this.openMiniMap;
      this.$bus.$emit('toggle_mini_map', this.openMiniMap);
    },

    showSearch() {
      this.$bus.$emit('show_search');
    },

    toggleDark() {
      this.setLocalConfig({
      });
    },

    backToRoot() {
      this.mindMap.renderer.setRootNodeCenter();
    }
  }
};
</script>

<style lang="less" scoped>
.navigatorContainer {
  padding: 0 12px;
  position: absolute;
  left: 20px;
  bottom: 20px;
  background: hsla(0, 0%, 100%, 0.8);
  border-radius: 5px;
  opacity: 0.8;
  height: 44px;
  font-size: 12px;
  display: flex;
  align-items: center;

  .item {
    margin-right: 20px;

    a {
      color: #303133;
      text-decoration: none;
    }

    .btn {
      cursor: pointer;
      font-size: 18px;
    }
  }
}

@media screen and (max-width: 590px) {
  .navigatorContainer {
    left: 20px;
    overflow-x: auto;
    overflow-y: hidden;
    height: 60px;
  }
}
</style>
